import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';

const TagsSection: FC = () => {
	const { list } = useTranslation('partner.tags');

	return (
		<section className={styles['ac-tags']}>
			<img className={styles.img1} src="https://web-data.zmlearn.com/image/mCLX3ynKg6pMMk6ndAvzRB/img_p2_left%20%402x.png" alt="" />
			<img className={styles.img2} src="https://web-data.zmlearn.com/image/kCLWzJvUwdSivRNkv4pgkU/img_p3_right%402x.png" alt="" />
			<div className={styles['ac-tags-container']}>
				{(list as any[]).map((item, i) => {
					return (
						<div className={styles['item']} key={i}>
							<div className={styles['icon']}>
								<img src={item.img} alt="" />
							</div>
							<div className={styles['total']}>{item.total}</div>
							<div className={styles['desc']}>{item.desc}</div>
						</div>
					);
				})}
			</div>
		</section>
	);
};

export default TagsSection;
